import {
  Component,
  inject,
  Injector,
  runInInjectionContext,
} from '@angular/core';
import { SiaAction, SiaActionFired, SiaActionsService } from '@sia/actions';
import {
  FileService,
  notify,
  retriveCurrentRouteData,
  SiaNewRouterService,
  SiaRouteData,
  SiaSessionService,
} from '@sia/shared';
import { Subscription } from 'rxjs';
import { SiaPdfViewerComponent } from '../../components/sia-pdf-viewer/sia-pdf-viewer.component';
import { PortalDocumentService } from '../../services/portal-document.service';

@Component({
  selector: 'sia-pdf-session-viewer',
  templateUrl: './sia-pdf-session-viewer.component.html',
  styleUrls: ['./sia-pdf-session-viewer.component.scss'],
  standalone: true,
  imports: [SiaPdfViewerComponent],
})
export class SiaPdfSessionViewerComponent {
  private routerService = inject(SiaNewRouterService);
  private portalDocumentService = inject(PortalDocumentService);
  private actionService = inject(SiaActionsService);
  private sessionService = inject(SiaSessionService);
  private fileService = inject(FileService);
  private injector: Injector = inject(Injector);

  private _subs: Subscription[] = [];
  pageData: SiaRouteData = {};
  documentBase64: any;
  path: string | null | undefined;
  configurationName: string | null | undefined;

  loadFile() {
    if (!this.pageData.componentId || !this.path) {
      return;
    }
    this.fileService.getBlob(this.path).then((res: any) => {
      this.documentBase64 = res;
    });
  }

  manageActionFired(action: SiaAction) {
    switch (action.id?.toLowerCase()) {
      case 'download':
        if (!this.path) {
          return;
        }
        try {
          this.fileService.downloadFile(
            this.path ?? '',
            this.path.split(/[\/\\]+/).pop() || 'download',
            true,
            false,
          );
        } catch (error) {
          console.error('Errore durante il download del file:', error);
          notify('Errore durante il download del file', 2000, 'error');
          return;
        }

        break;

      default:
        break;
    }
  }

  ngOnDestroy() {
    this._subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
  ngAfterViewInit() {
    let s0 = this.routerService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData;
      this.path = this.sessionService.getSessionParamValue('path');
      this.configurationName =
        this.sessionService.getSessionParamValue('configurationType');
      this.loadFile();
    });
    this._subs.push(s0);
    let s1 = this.actionService
      .actionFired$()
      .subscribe((action: SiaActionFired) => {
        if (
          action &&
          action.action &&
          action.guid == this.pageData.guid &&
          action.componentId == this.pageData.componentId
        ) {
          this.manageActionFired(action.action);
        }
      });
    this._subs.push(s1);
  }
}
